import moment from 'moment';
import 'moment/locale/pl';
import i18n from 'i18next';

/**
 * Capitalize first letter of a string.
 * @param {string} string The string to capitalize.
 * @returns {string} String with the first letter capitalized.
 */
const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Format date
 *
 * @param {string} date Date to be formatted
 * @param {string} format Desired date format
 * @returns {string} Formatted date
 */
export default (date, format = i18n.t('Common:localDateFormat', 'DD MMMM YYYY')) => {
  const lang = i18n.t('Common:en');
  let formattedDate = date ? moment(date).locale(lang).format(format) : '';
  return formattedDate.split(' ').map((word, index) => index === 1 ? capitalizeFirstLetter(word) : word).join(' ');
};
